module.exports = __webpack_public_path__ + "static/grafika5@2x-1fd0fea8ecf8aa691e8dcdd8bedc0533.png";